module.exports = __webpack_public_path__ + "img/image1.be6bed07.jpg";